module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ProgressDots"
    }
  }, [_c('div', {
    staticClass: "col-xs-offset-2 col-xs-8"
  }, [_c('div', {
    staticClass: "csp-progress-group"
  }, _vm._l((_vm.totalSteps), function(n) {
    return _c('div', {
      staticClass: "csp-progress-dot",
      class: {
        'primary-color': n == _vm.currentStep
      }
    })
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09046f97!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgressDots.vue
// module id = 849
// module chunks = 2